import CustomUIImageStyle from "./CustomUIImageStyle";
import { FileReader, FileWriter } from '@/platform'

class PersonFavourItem{
  public ID: number = 0
  public Name: string = ''
  public NameColor: Array<number> = []
  public FaceImage: CustomUIImageStyle = new CustomUIImageStyle()
  public ExtractImage: CustomUIImageStyle = new CustomUIImageStyle()
  public ExtractX: number = 0
  public ExtractY: number = 0
  public CurrentFavoutValue: string = ''
  public MaxFavoutValue: string = ''

  constructor(param?: {
    name: string;
    extractX: number;
    extractY: number;
    currentFavoutValue: string;
    maxFavoutValue: string;
  }) {
    if (param) {
      const { name, extractX, extractY, currentFavoutValue, maxFavoutValue } =
        param;

      this.ID = 0;
      this.Name = name;
      this.NameColor = [255, 255, 255, 255];
      this.ExtractX = extractX;
      this.ExtractY = extractY;
      this.CurrentFavoutValue = currentFavoutValue;
      this.MaxFavoutValue = maxFavoutValue;
      this.FaceImage = new CustomUIImageStyle();
      this.ExtractImage = new CustomUIImageStyle();
    } else {
      this.ID = 0;
      this.Name = "";
      this.NameColor = [255, 255, 255, 255];
      this.ExtractX = 0;
      this.ExtractY = 0;
      this.CurrentFavoutValue = "";
      this.MaxFavoutValue = "";
      this.FaceImage = new CustomUIImageStyle();
      this.ExtractImage = new CustomUIImageStyle();
    }
  }

  public readBin(reader: FileReader): void {
    this.ID = reader.readInt()
    this.Name = reader.readString()
    const ncLen = reader.readInt()
    this.NameColor = []
    for (let i = 0; i < ncLen; i++) {
      this.NameColor.push(reader.readInt())
    }
    this.FaceImage = new CustomUIImageStyle(reader)
    this.ExtractImage = new CustomUIImageStyle(reader)
    this.ExtractX = reader.readInt()
    this.ExtractY = reader.readInt()
    this.CurrentFavoutValue = reader.readString()
    this.MaxFavoutValue = reader.readString()
  }

  public writeBin(writer: FileWriter): void {
    writer.writeInt(this.ID)
    writer.writeString(this.Name)
    writer.writeInt(this.NameColor.length)
    for (let i = 0; i < this.NameColor.length; i++) {
      writer.writeInt(this.NameColor[i]!)
    }
    this.FaceImage.writeBin(writer)
    this.ExtractImage.writeBin(writer)
    writer.writeInt(this.ExtractX)
    writer.writeInt(this.ExtractY)
    writer.writeString(this.CurrentFavoutValue)
    writer.writeString(this.MaxFavoutValue)
  }
}

export default PersonFavourItem;
